export const RDX_NTF_ADD = 'rdx/notify/add';
export const RDX_NTF_REMOVE = 'rdx/notify/remove';
export const RDX_NTF_RESET = 'rdx/notify/set';

export const addNotify = (noti, key) => {
	if (!noti.noScrollUp) {
		window.scrollTo(0, 0);
	}
	return { 'type': RDX_NTF_ADD, 'msg': noti, 'ns': key };
};
export const removeNotify = (key) => {
	return { 'type': RDX_NTF_REMOVE, 'ns': key };
};
export const resetNotify = () => {
	return { 'type': RDX_NTF_RESET };
};